import script from "./web-footer.vue?vue&type=script&setup=true&lang=js"
export * from "./web-footer.vue?vue&type=script&setup=true&lang=js"

import "./web-footer.vue?vue&type=style&index=0&id=322945da&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-322945da"]])

export default __exports__